jQuery_T4NT(document).ready(function($) {

     /**
     *  Variant selection changed
     *  data-variant-toggle="{{ variant.id }}"
     */
	   $( document ).on( "variant:changed", function( evt ) {
	     // console.log( evt.currentVariant );
	     // $('[data-variant-toggle]').hide(0);
	     // $('[data-variant-toggle="'+evt.currentVariant.id+'"]').show(0);
	   });
});



// ------header menu and drawer--------------------------

document.addEventListener("DOMContentLoaded", function () {
  const menuButton = document.querySelector('#shopify-section-header-sidebar .t4s-push-menu-btn');
  const closeButton = document.querySelector('.t4s-drawer-menu__close');
  const closeOverlay = document.querySelector('body .t4s-close-overlay');
  const topBar = document.querySelector('#shopify-section-top-bar');
  const menuButtonSVG = menuButton ? menuButton.querySelector('svg') : null;

  function updateTopBarVisibility(show) {
    if (!topBar) return;

    if (!show) {
      topBar.classList.add('t4s-hidden');
    } else {
      topBar.classList.remove('t4s-hidden');
    }
  }

  // Add classes on menu button click (open menu)
  if (menuButton) {
    menuButton.addEventListener('click', function () {
      document.body.classList.add('t4s-hsticky__ready', 'is-header--stuck');
      updateTopBarVisibility(false); // hide top bar
      if (menuButtonSVG) menuButtonSVG.style.display = 'none';
    });
  }

  // Handle smooth menu close
  function handleSmoothClose() {
    // Add a class for closing animation
    document.body.classList.add('t4s-menu-closing');

    // Delay actual class removal to allow animation
    setTimeout(() => {
      document.body.classList.remove('t4s-hsticky__ready', 'is-header--stuck', 't4s-menu-closing');
      updateTopBarVisibility(true); // show top bar again
      if (menuButtonSVG) menuButtonSVG.style.display = '';
    }, 300); // match your transition duration in CSS
  }

  // Close button click
  if (closeButton) {
    closeButton.addEventListener('click', handleSmoothClose);
  }

  // Overlay click
  if (closeOverlay) {
    closeOverlay.addEventListener('click', handleSmoothClose);
  }
});



// document.addEventListener("DOMContentLoaded", function () {
//   const menuButton = document.querySelector('#shopify-section-header-sidebar .t4s-push-menu-btn');
//   const closeButton = document.querySelector('.t4s-drawer-menu__close');
//   const closeOverlay = document.querySelector('body .t4s-close-overlay');
//   const topBar = document.querySelector('#shopify-section-top-bar');
//   const menuButtonSVG = menuButton ? menuButton.querySelector('svg') : null;

//   function updateTopBarVisibility() {
//     if (document.body.classList.contains('t4s-hsticky__ready') && document.body.classList.contains('is-header--stuck')) {
//       if (topBar) topBar.style.display = 'none';
//     } else {
//       if (topBar) topBar.style.display = '';
//     }
//   }

//   // Add classes on menu button click
//   if (menuButton) {
//     menuButton.addEventListener('click', function () {
//       document.body.classList.add('t4s-hsticky__ready', 'is-header--stuck');
//       updateTopBarVisibility();
//       if (menuButtonSVG) menuButtonSVG.style.display = 'none';
//     });
//   }

//   // Remove classes on close button click
//   if (closeButton) {
//     closeButton.addEventListener('click', function () {
//       document.body.classList.remove('t4s-hsticky__ready', 'is-header--stuck');
//       updateTopBarVisibility();
//       if (menuButtonSVG) menuButtonSVG.style.display = '';
//     });
//   }

//   // Remove classes on overlay click
//   if (closeOverlay) {
//     closeOverlay.addEventListener('click', function () {
//       document.body.classList.remove('t4s-hsticky__ready', 'is-header--stuck');
//       updateTopBarVisibility();
//       if (menuButtonSVG) menuButtonSVG.style.display = '';
//     });
//   }
// });


